/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum BlackboxExporterModule {
    http = 0,
    https = 1,
    https_strict = 2,
    tcp_connect = 3,
    icmp = 4,
    icmp_ttl5 = 5,
}
